import {
  buildCutInstructionDescriptor,
  buildEdgeTextDescriptor,
} from "../messages/exportMessages.js";

export function getPanelOrderSize(panel) {
  const finalLength = Number(panel.length || 0);
  const finalWidth = Number(panel.width || 0);
  const hasPanelOrderLength = panel.orderLength != null && panel.orderLength !== "";
  const hasPanelOrderWidth = panel.orderWidth != null && panel.orderWidth !== "";

  return {
    finalLength,
    finalWidth,
    panelOrderLength: hasPanelOrderLength ? Number(panel.orderLength) : null,
    panelOrderWidth: hasPanelOrderWidth ? Number(panel.orderWidth) : null,
    orderLength: hasPanelOrderLength ? Number(panel.orderLength) : finalLength,
    orderWidth: hasPanelOrderWidth ? Number(panel.orderWidth) : finalWidth,
  };
}

export function getEdgeText(edges = {}) {
  return buildEdgeTextDescriptor(edges);
}

export function getCutInstruction(panel) {
  return buildCutInstructionDescriptor(panel);
}

export function getFlatOrderRows(project) {
  return project.projects.flatMap((subproject) =>
    subproject.panels
      .filter((panel) => !panel.hidden && Number(panel.length) > 0 && Number(panel.width) > 0 && Number(panel.quantity) > 0)
      .map((panel) => ({
        id: panel.id,
        projectName: subproject.name,
        name: panel.name || { key: "core.unnamedPanel" },
        materialName: project.materialName,
        thickness: Number(panel.thickness || project.sourcePanel.defaultThickness),
        quantity: Number(panel.quantity || 1),
        edges: getEdgeText(panel.edges),
        instruction: getCutInstruction(panel),
        ...getPanelOrderSize(panel),
      })),
  );
}

export function groupRowsByThickness(rows) {
  return rows.reduce((groups, row) => {
    const key = row.thickness;
    groups[key] = groups[key] || [];
    groups[key].push(row);
    return groups;
  }, {});
}

export function getPlateNumbersForPanel(layout, panelId) {
  const plates = [];
  layout.sheets.forEach((sheet) => {
    if (sheet.placements.some((placement) => placement.panelId === panelId)) {
      plates.push(sheet.index + 1);
    }
  });
  return plates.join(", ");
}
